export const linkTypes = ['playerLink', 'recipientPlayerLink', 'teamLink'] as const;

export type LinkType = (typeof linkTypes)[number];
